import React, { lazy, Component } from "react";
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import "../globalStyles/doctorProfileStyle.css";
import Footer from "./Footer";
import Header from "./Header";
import swal from "sweetalert";
import authAxios from "../Util/API Calls/authAxios";
import afterLoginApiAxios from "../Util/API Calls/afterLogin";
import OtpInput from "react-otp-input";
import GlobalFooter from "./GlobalFooter";
import { doctorProfileFiles } from "../Util/API Calls/APIList";
import Loader from "./UI Component/Loader/Loader";
import { connect } from "react-redux";
import UserBrowser from "./UserBrowser";
import { LOCALSTORAGEKEY } from "../Util/Helper/localStorageUtils";
import { C2CConsole } from "../Util/Helper/C2CConsole";

const formValid = (formErrors) => {
  let valid = true;
  Object.values(formErrors).forEach((val) => {
    val.length > 0 && (valid = false);
  });
  return valid;
};

const onlyDigitRegex = RegExp(/^[0-9]+$/);

class DoctorProfile extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeUser = this.handleChangeUser.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.goToPatientDetails.bind(this);
    this.goToLoginToBook.bind(this);

    var slug = this.props.match.params.slug;
    this.state = {
      send: "Send",
      docType: "",
      doctor: "",
      URL: doctorProfileFiles,
      slot_id: "",
      slot_list: [],
      bgColor: "#eeae01",
      dateArr: [],
      sdate: [],
      doc_id: "",
      start: "",
      apt_date: "",
      data_flag: true,
      dis_slot: [],
      modalFlag: false,
      new_user: "true",
      slug: slug,
      dateList: [],
      dayList: [],
      morning: [],
      dis_slot_morning: [],
      afternoon: [],
      dis_slot_afternoon: [],
      evening: [],
      dis_slot_evening: [],
      dateColor: [],
      btnColor: [],
      btnColorM: [],
      btnColorA: [],
      btnColorE: [],
      otp_message: "",
      showOtpTimer: false,
      otpTimer: {
        minutes: 2,
        seconds: 0,
      },
      mor_flag: false,
      after_flag: false,
      eve_flag: false,

      phone_number: "",
      otp: "",
      formErrors: {
        phone_number: "",
        otp: "",
      },
      validation_msg: "",
      loading: false,
    };
  }

  handleChangeForm = (name) => (event) => {
    const target = event.target;
    const { name, value } = event.target;
    let formErrors = this.state.formErrors;
    if (name == "otp") {
      formErrors.otp = "";
      this.setState(
        {
          otp: event.target.value,
          formErrors: formErrors,
        },
        () => {}
      );
    } else {
      if (value.length > 0) {
        formErrors.phone_number =
          onlyDigitRegex.test(value) && value.length == 10
            ? ""
            : "Please enter valid Phone Number";
        this.setState(
          {
            phone_number: event.target.value,
            formErrors: formErrors,
          },
          () => {}
        );
        //this.setState({formErrors});
      } else {
        formErrors.phone_number =
          value.length >= 10 ? "" : " Phone Number is Mandatory";
        this.setState(
          {
            phone_number: event.target.value,
            formErrors: formErrors,
          },
          () => {}
        );
      }
    }
  };

  handleOtp = (otp) => this.setState({ otp });

  onSubmit(event) {
    if (
      this.state.phone_number != "" &&
      this.state.otp != "" &&
      formValid(this.state.formErrors) &&
      this.state.otp.length == 6
    ) {
      var phone_no = "+91" + this.state.phone_number;

      var data = {
        phone_no: phone_no,
        user_otp: this.state.otp,
        user_type: "patient",
      };

      this.setState(
        {
          validation_msg: "",
          loading: true,
        },
        () => {}
      );

      authAxios
        .post(
          "login",
          {
            phone_no: phone_no,
            user_otp: this.state.otp,
            user_type: "patient",
          },
          {
            headers: {
              "Content-Type": "application/json",
              //"Authorization" : token
            },
          }
        )
        .then((response) => {
          this.setState({ loading: false });

          if (response) {
            if (response.data.hasOwnProperty("statusCode")) {
              if (response.data.statusCode == 200) {
                localStorage.setItem("id_token", response.data.user.id_token);
                localStorage.setItem("user_name", response.data.user.user_name);
                localStorage.setItem("user_type", response.data.user.user_type);
                localStorage.setItem(
                  LOCALSTORAGEKEY.USER_ID,
                  response.data.user.user_id
                );
                localStorage.setItem("slot_id", this.state.slot_id);
                localStorage.setItem("start", this.state.start);
                localStorage.setItem("date", this.state.apt_date);
                localStorage.setItem(
                  "doctor",
                  JSON.stringify(this.state.doctor)
                );

                this.setState({}, () => {});
                var message = response.data.message;
                this.props.history.push("/appointments/book");
              } else {
                var message = response.data.message;
                swal({
                  title: "Login Failed!",
                  text: message,
                  type: "error",
                  icon: "warning",
                }).then(function () {
                  window.location.reload();
                });
              }
            } else {
              var message = "Something Went Wrong!!Try Again";
              swal({
                title: "Login Failed!",
                text: message,
                type: "error",
                icon: "warning",
              }).then(function () {});
            }
          } else {
            var message = "Something Went Wrong!!Try Again";
            swal({
              title: "Login Failed!",
              text: message,
              type: "error",
              icon: "warning",
            }).then(function () {});
          }
        })
        .catch((error) => {
          this.setState({ loading: false });

          C2CConsole.log(error);
        });
    } else {
      let formErrors = this.state.formErrors;
      formErrors = {
        phone_number: "",
        otp: "",
      };
      if (!this.state.phone_number) {
        formErrors.phone_number = "Phone Number is Mandatory";
        this.setState({ formErrors });
      } else if (
        this.state.phone_number.length > 0 &&
        this.state.phone_number.length < 10
      ) {
        formErrors.phone_number = "Provide Valid Phone Number";
        this.setState({ formErrors });
        this.setState({
          otp_message: "",
        });
      } else {
        formErrors.otp = "Provide Valid Otp";
        this.setState({ formErrors });
        this.setState({
          otp_message: "",
        });
      }
    }
  }

  startTimer = () => {
    this.setState({ showOtpTimer: true });
    this.myInterval = setInterval(() => {
      const { seconds, minutes } = this.state.otpTimer;
      if (seconds > 0) {
        this.setState(({ otpTimer }) => ({
          otpTimer: {
            ...otpTimer,
            seconds: otpTimer.seconds - 1,
          },
        }));
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.myInterval);
          this.setState({
            showOtpTimer: false,
          });
        } else {
          this.setState(({ otpTimer }) => ({
            otpTimer: {
              minutes: otpTimer.minutes - 1,
              seconds: 59,
            },
          }));
        }
      }
    }, 1000);
  };

  onOtpSend(event) {
    let formErrors = this.state.formErrors;
    if (
      !this.state.phone_number ||
      this.state.phone_number.length <= 9 ||
      this.state.phone_number.length >= 11
    ) {
      formErrors.phone_number = "Please Provide Valid Phone Number";
      this.setState({ formErrors });
    } else if (Number(this.state.phone_number) < 1000000000) {
      formErrors.phone_number = "Please Provide Valid Phone Number";
      this.setState({ formErrors });
    } else {
      var phonenumber = this.state.phone_number;
      var phone_number = "+91" + phonenumber; //+918017029639

      formErrors.otp = "";

      //Start Timer
      this.setState({
        otpTimer: {
          minutes: 2,
          seconds: 0,
        },
        formErrors: formErrors,
        loading: true,
      });
      clearInterval(this.myInterval);

      afterLoginApiAxios
        .post("public/send-otp", {
          phone_no: phone_number,
          channel_id: "patient-login",
        })
        .then((response) => {
          this.setState({ loading: false });

          var message = "";
          if (response) {
            if (response.data.hasOwnProperty("statusCode")) {
              if (response.data.statusCode == 200) {
                this.setState(
                  {
                    send: "Resend",
                  },
                  () => {}
                );
                message = response.data.message;

                this.startTimer();
              } else {
                message = response.data.message;
              }
            } else {
              message = "Something Went Wrong!!Try Again";
            }
          } else {
            message = "Something Went Wrong!!Try Again";
          }

          this.setState({
            otp_message: message,
          });
        })
        .catch((error) => {
          this.setState({ loading: false });

          C2CConsole.log(error);
        });
    }
  }

  openModal() {
    this.setState({
      modalFlag: true,
    });
  }

  closeModal() {
    this.setState({
      modalFlag: false,
      send: "Send",
      otp_message: "",
      formErrors: {
        phone_number: "",
        otp: "",
      },
    });
  }

  setSlot(id, start, index, dayPhase) {
    this.setState({
      slot_id: id,
      bgColor: "#2f2f2f",
      start: start,
    });

    var btncolor = [];
    var phase;
    if (dayPhase == "morning") {
      phase = this.state.morning;
    } else if (dayPhase == "afternoon") {
      phase = this.state.afternoon;
    } else {
      phase = this.state.evening;
    }

    for (var i = 0; i < phase.length; i++) {
      if (i == index) {
        btncolor[i] = "#1B2027";
      } else {
        btncolor[i] = "#F5F6F7";
      }
    }

    if (dayPhase == "morning") {
      this.setState({
        btnColorM: btncolor,
        btnColorA: [],
        btnColorE: [],
      });
    } else if (dayPhase == "afternoon") {
      this.setState({
        btnColorA: btncolor,
        btnColorM: [],
        btnColorE: [],
      });
    } else {
      this.setState({
        btnColorE: btncolor,
        btnColorA: [],
        btnColorM: [],
      });
    }
  }

  goToPatientDetails(event, doctor) {
    var sid = this.state.slot_id;
    var start = this.state.start;
    var date = this.state.apt_date;
    var doctor =
      this.state.doctor.first_name + " " + this.state.doctor.last_name;
    var new_user = 1;
    localStorage.setItem("schedule_sid", sid);
    localStorage.setItem("schedule_start", start);
    localStorage.setItem("schedule_date", date);
    localStorage.setItem("schedule_doctor", doctor);
    localStorage.setItem("schedule_new_user", new_user);
    this.props.history.push("/patient/details");
  }
  goToLoginToBook(event) {
    var sid = this.state.slot_id;
    var start = this.state.start;
    var date = this.state.apt_date;
    var doctor =
      this.state.doctor.first_name + " " + this.state.doctor.last_name;
    var new_user = 0;
    localStorage.setItem("schedule_sid", sid);
    localStorage.setItem("schedule_start", start);
    localStorage.setItem("schedule_date", date);
    localStorage.setItem("schedule_doctor", doctor);
    localStorage.setItem("schedule_new_user", new_user);
    this.props.history.push("/logintobook");
  }
  componentWillMount() {
    //localStorage.removeItem("id_token");

    var tempDate = new Date();
    var dateToday =
      tempDate.getFullYear() +
      "-" +
      (tempDate.getMonth() + 1) +
      "-" +
      tempDate.getDate();

    var dateArray = [];
    var date = [];
    var monthArray = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    var dayArray = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    var febdays;
    if (tempDate.getYear() % 4 == 0) {
      febdays = 29;
    } else {
      febdays = 28;
    }
    var days_month = [31, febdays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    var c = 0;
    var temp = tempDate.getDate();
    var d = tempDate.getDay();

    var dateL = [];
    var dayL = [];

    for (var i = temp; i < temp + 7; i++) {
      if (d + c < 7) {
        if (i <= days_month[tempDate.getMonth()]) {
          dateL[c] =
            i.toString() +
            " " +
            monthArray[tempDate.getMonth()].substring(0, 3);
          dayL[c] = dayArray[d + c];

          dateArray[c] =
            monthArray[tempDate.getMonth()] +
            " " +
            i.toString() +
            "," +
            dayArray[d + c];

          date[c] =
            tempDate.getFullYear() +
            "-" +
            (tempDate.getMonth() + 1) +
            "-" +
            i.toString();
        } else {
          dateL[c] =
            (i - days_month[tempDate.getMonth()]).toString() +
            " " +
            monthArray[tempDate.getMonth() + 1].substring(0, 3);
          dayL[c] = dayArray[d + c];

          dateArray[c] =
            monthArray[tempDate.getMonth() + 1] +
            " " +
            (i - days_month[tempDate.getMonth()]).toString() +
            "," +
            dayArray[d + c];

          date[c] =
            tempDate.getFullYear() +
            "-" +
            (tempDate.getMonth() + 2) +
            "-" +
            (i - days_month[tempDate.getMonth()]).toString();
        }
      } else {
        if (i <= days_month[tempDate.getMonth()]) {
          dateL[c] =
            i.toString() +
            " " +
            monthArray[tempDate.getMonth()].substring(0, 3);
          dayL[c] = dayArray[d + c - 7];

          dateArray[c] =
            monthArray[tempDate.getMonth()] +
            " " +
            i.toString() +
            "," +
            dayArray[d + c - 7];

          date[c] =
            tempDate.getFullYear() +
            "-" +
            (tempDate.getMonth() + 1) +
            "-" +
            i.toString();
        } else {
          dateL[c] =
            (i - days_month[tempDate.getMonth()]).toString() +
            " " +
            monthArray[tempDate.getMonth() + 1].substring(0, 3);
          dayL[c] = dayArray[d + c - 7];

          dateArray[c] =
            monthArray[tempDate.getMonth() + 1] +
            " " +
            (i - days_month[tempDate.getMonth()]).toString() +
            "," +
            dayArray[d + c - 7];

          date[c] =
            tempDate.getFullYear() +
            "-" +
            (tempDate.getMonth() + 2) +
            "-" +
            (i - days_month[tempDate.getMonth()]).toString();
        }
      }

      c++;
    }

    this.setState({
      dateArr: dateArray,
      sdate: date,
      apt_date: dateToday,
      dateList: dateL,
      dayList: dayL,
      dateColor: [
        "#F969A4",
        "#1B2027",
        "#1B2027",
        "#1B2027",
        "#1B2027",
        "#1B2027",
        "#1B2027",
      ],
    });

    afterLoginApiAxios
      .post("public/get-doctor-details-by-slug", {
        doctor_url_short_code: this.state.slug,
      })
      .then((response) => {
        if (response) {
          var responseData = response.data;

          if (response.status == 403) {
            this.props.history.push("/");
          }

          if (responseData) {
            if (responseData.statusCode == 200) {
              localStorage.setItem("category", responseData.category);
              this.setState({
                doctor: responseData.doctor,
                doc_id: responseData.doctor.doctor_id,
              });

              if (responseData) {
                afterLoginApiAxios
                  .post("public/get-booking-slots-by-doctor-id", {
                    doctor_id: this.state.doctor.doctor_id,
                    date: dateToday,
                  })
                  .then((response) => {
                    if (response) {
                      var responseData = response.data;

                      if (responseData) {
                        if (responseData.statusCode == 200) {
                          this.setState({
                            slot_list: responseData.time_slots,
                            doc_id: this.state.doctor.doctor_id,
                          });
                        } else {
                          this.setState({
                            data_flag: false,
                            slot_list: [],
                          });
                        }

                        var dis_slot = [];

                        var currentHours;
                        if (tempDate.getHours() > 12) {
                          currentHours = tempDate.getHours() - 12;
                        } else {
                          currentHours = tempDate.getHours();
                        }

                        for (var i = 0; i < this.state.slot_list.length; i++) {
                          var time = Number(
                            this.state.slot_list[i].start_time.substring(0, 2)
                          );

                          var am_pm = this.state.slot_list[
                            i
                          ].start_time.substring(6, 8);

                          if (tempDate.getHours() > 12) {
                            if (am_pm == "AM") {
                              dis_slot[i] = false;
                            } else {
                              if (currentHours > time || time == 12) {
                                dis_slot[i] = false;
                              } else {
                                if (currentHours == time) {
                                  if (
                                    tempDate.getMinutes() <= 25 ||
                                    Number(
                                      this.state.slot_list[
                                        i
                                      ].start_time.substring(3, 5)
                                    ) == 30
                                  )
                                    dis_slot[i] = true;
                                  else dis_slot[i] = false;
                                } else {
                                  dis_slot[i] = true;
                                }
                              }
                            }
                          } else {
                            if (am_pm == "PM") {
                              dis_slot[i] = true;
                            } else {
                              if (
                                currentHours > time ||
                                (time == 12 && currentHours != 0)
                              ) {
                                dis_slot[i] = false;
                              } else {
                                if (currentHours == time) {
                                  if (
                                    tempDate.getMinutes() <= 25 ||
                                    Number(
                                      this.state.slot_list[
                                        i
                                      ].start_time.substring(3, 5)
                                    ) == 30
                                  )
                                    dis_slot[i] = true;
                                  else dis_slot[i] = false;
                                } else {
                                  dis_slot[i] = true;
                                }
                              }
                            }
                          }

                          this.setState({
                            dis_slot: dis_slot,
                          });
                        }
                      }

                      var mor = [];
                      var after = [];
                      var eve = [];
                      var m = 0,
                        a = 0,
                        e = 0;
                      var dis_mor = [],
                        dis_aft = [],
                        dis_eve = [];

                      for (var i = 0; i < this.state.slot_list.length; i++) {
                        if (
                          this.state.slot_list[i].start_time.substring(6, 8) ==
                          "AM"
                        ) {
                          mor[m] = this.state.slot_list[i];
                          dis_mor[m] = this.state.dis_slot[i];

                          if (
                            this.state.slot_list[i].patient_status == 0 &&
                            this.state.dis_slot[i] == true
                          ) {
                            this.setState({
                              mor_flag: true,
                            });
                          }

                          m++;
                        } else {
                          if (
                            Number(
                              this.state.slot_list[i].start_time.substring(0, 2)
                            ) < 6 ||
                            Number(
                              this.state.slot_list[i].start_time.substring(0, 2)
                            ) == 12
                          ) {
                            after[a] = this.state.slot_list[i];
                            dis_aft[a] = this.state.dis_slot[i];

                            if (
                              this.state.slot_list[i].patient_status == 0 &&
                              this.state.dis_slot[i] == true
                            ) {
                              this.setState({
                                after_flag: true,
                              });
                            }

                            a++;
                          } else {
                            eve[e] = this.state.slot_list[i];
                            dis_eve[e] = this.state.dis_slot[i];

                            if (
                              this.state.slot_list[i].patient_status == 0 &&
                              this.state.dis_slot[i] == true
                            ) {
                              this.setState({
                                eve_flag: true,
                              });
                            }

                            e++;
                          }
                        }
                      }

                      this.setState({
                        morning: mor,
                        afternoon: after,
                        evening: eve,
                        dis_slot_morning: dis_mor,
                        dis_slot_afternoon: dis_aft,
                        dis_slot_evening: dis_eve,
                      });
                    }
                  })
                  .catch(function (error) {
                    C2CConsole.log(error);
                  });
              }
            } else if (responseData.statusCode == 503) {
              this.props.history.push("/");
            }
          }
        }
      })
      .catch(function (error) {
        C2CConsole.log(error);
      });
  }

  handleChange(sdate, index) {
    var dateValue = sdate;

    var doc_id = this.state.doc_id;
    var color = [];

    for (var i = 0; i < 7; i++) {
      if (i == index) {
        color[i] = "#F969A4";
      } else {
        color[i] = "#1B2027";
      }
    }

    var tempDate = new Date();
    var dateToday =
      tempDate.getFullYear() +
      "-" +
      (tempDate.getMonth() + 1) +
      "-" +
      tempDate.getDate();

    this.setState({
      apt_date: dateValue,
      dateColor: color,
      slot_id: "",
      btnColorM: [],
      btnColorA: [],
      btnColorE: [],
      mor_flag: false,
      after_flag: false,
      eve_flag: false,
    });

    var temp_slots = [];
    if (sdate) {
      afterLoginApiAxios
        .post("public/get-booking-slots-by-doctor-id", {
          doctor_id: this.state.doctor.doctor_id,
          date: dateValue,
        })
        .then((response) => {
          if (response) {
            var responseData = response.data;

            if (responseData) {
              if (responseData.statusCode == 200) {
                if (responseData.time_slots) {
                  this.setState({
                    slot_list: responseData.time_slots,
                    data_flag: true,
                  });

                  var dis_slot = [];
                  var currentHours;
                  if (tempDate.getHours() > 12) {
                    currentHours = tempDate.getHours() - 12;
                  } else {
                    currentHours = tempDate.getHours();
                  }

                  if (tempDate.getDate() == dateValue.substring(7, 9)) {
                    for (var i = 0; i < this.state.slot_list.length; i++) {
                      var time = Number(
                        this.state.slot_list[i].start_time.substring(0, 2)
                      );

                      var am_pm = this.state.slot_list[i].start_time.substring(
                        6,
                        8
                      );

                      if (tempDate.getHours() > 12) {
                        if (am_pm == "AM") {
                          dis_slot[i] = false;
                        } else {
                          if (currentHours > time || time == 12) {
                            dis_slot[i] = false;
                          } else {
                            if (currentHours == time) {
                              if (
                                tempDate.getMinutes() <= 25 ||
                                Number(
                                  this.state.slot_list[i].start_time.substring(
                                    3,
                                    5
                                  )
                                ) == 30
                              )
                                dis_slot[i] = true;
                              else dis_slot[i] = false;
                            } else {
                              dis_slot[i] = true;
                            }
                          }
                        }
                      } else {
                        if (am_pm == "PM") {
                          dis_slot[i] = true;
                        } else {
                          if (
                            currentHours > time ||
                            (time == 12 && currentHours != 0)
                          ) {
                            dis_slot[i] = false;
                          } else {
                            if (currentHours == time) {
                              if (
                                tempDate.getMinutes() <= 25 ||
                                Number(
                                  this.state.slot_list[i].start_time.substring(
                                    3,
                                    5
                                  )
                                ) == 30
                              )
                                dis_slot[i] = true;
                              else dis_slot[i] = false;
                            } else {
                              dis_slot[i] = true;
                            }
                          }
                        }
                      }

                      this.setState({
                        dis_slot: dis_slot,
                      });
                    }
                  } else {
                    for (var i = 0; i < this.state.slot_list.length; i++) {
                      dis_slot[i] = true;
                    }

                    this.setState({
                      dis_slot: dis_slot,
                    });
                  }
                } else {
                  this.setState({
                    slot_list: [],
                    data_flag: false,
                  });
                }
              } else {
                this.setState({
                  data_flag: false,
                  slot_list: [],
                });
              }
            }

            var mor = [];
            var after = [];
            var eve = [];
            var m = 0,
              a = 0,
              e = 0;
            var dis_mor = [],
              dis_aft = [],
              dis_eve = [];

            for (var i = 0; i < this.state.slot_list.length; i++) {
              if (this.state.slot_list[i].start_time.substring(6, 8) == "AM") {
                mor[m] = this.state.slot_list[i];
                dis_mor[m] = this.state.dis_slot[i];

                if (
                  this.state.slot_list[i].patient_status == 0 &&
                  this.state.dis_slot[i] == true
                ) {
                  this.setState({
                    mor_flag: true,
                  });
                }

                m++;
              } else {
                if (
                  Number(this.state.slot_list[i].start_time.substring(0, 2)) <
                    6 ||
                  Number(this.state.slot_list[i].start_time.substring(0, 2)) ==
                    12
                ) {
                  after[a] = this.state.slot_list[i];
                  dis_aft[a] = this.state.dis_slot[i];

                  if (
                    this.state.slot_list[i].patient_status == 0 &&
                    this.state.dis_slot[i] == true
                  ) {
                    this.setState({
                      after_flag: true,
                    });
                  }

                  a++;
                } else {
                  eve[e] = this.state.slot_list[i];
                  dis_eve[e] = this.state.dis_slot[i];

                  if (
                    this.state.slot_list[i].patient_status == 0 &&
                    this.state.dis_slot[i] == true
                  ) {
                    this.setState({
                      eve_flag: true,
                    });
                  }

                  e++;
                }
              }
            }

            this.setState({
              morning: mor,
              afternoon: after,
              evening: eve,
              dis_slot_morning: dis_mor,
              dis_slot_afternoon: dis_aft,
              dis_slot_evening: dis_eve,
            });
          }
        })
        .catch(function (error) {
          C2CConsole.log(error);
        });
    }
  }

  handleChangeUser = (name) => (event) => {
    const target = event.target;
    const { name, value } = event.target;

    if (name === "new_user") {
      this.setState(
        {
          new_user: event.target.value,
        },
        () => {}
      );
    }
  };

  render() {
    return (
      <div>
        {this.state.loading ? <Loader /> : null}

        <Header />
        <section className="pro-body-content">
          <div className="pro-content">
            <div className="container-fluid">
              <div className="pro-content-col">
                <div className="row">
                  <div className="col-md-4 doctor-profile">
                    <div className="profile-img">
                      <img
                        src={
                          this.state.URL + this.state.doctor.profile_picture_url
                        }
                        alt=""
                      />
                    </div>
                    <h3>
                      {this.state.doctor.prefix_name}{" "}
                      {this.state.doctor.first_name}&nbsp;
                      {this.state.doctor.last_name}
                    </h3>
                    <h4 className="mb-2">{this.state.doctor.display_name}</h4>
                    <h4
                      style={{
                        marginBottom: "30px",
                        color: "#878782",
                        fontSize: "14px",
                      }}
                    >
                      Regd No: {this.state.doctor.medical_reg_no}
                    </h4>
                    <ul className="doc-info">
                      <li>
                        <img
                          src={process.env.PUBLIC_URL + "/images/pro-icon1.png"}
                          alt=""
                        />
                        <p>{this.state.doctor.degree}</p>
                      </li>
                      <li>
                        <img
                          src={process.env.PUBLIC_URL + "/images/pro-icon2.png"}
                          alt=""
                        />
                        <p>{this.state.doctor.about}</p>
                      </li>
                      <li>
                        <img
                          src={process.env.PUBLIC_URL + "/images/pro-icon3.png"}
                          alt=""
                        />
                        <p>{this.state.doctor.description}</p>
                      </li>
                      <li>
                        <img
                          src={process.env.PUBLIC_URL + "/images/pro-icon4.png"}
                          alt=""
                        />
                        <h5>INR {this.state.doctor.total_fees}</h5>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-8">
                    <div className="pro-calender">
                      <h2>BOOK APPOINTMENT</h2>
                      <div className="scrtabs-tab-container">
                        <div className="scrtabs-tab-scroll-arrow scrtabs-tab-scroll-arrow-left">
                          <span className="fa fa-angle-left"></span>
                        </div>
                        <div className="scrtabs-tabs-fixed-container">
                          <div className="scrtabs-tabs-movable-container">
                            <ul className="nav nav-tabs" role="tablist">
                              {this.state.dateArr.map((date, index) => {
                                return (
                                  <li role="presentation">
                                    <a
                                      href="#"
                                      role="tab"
                                      style={{
                                        color: this.state.dateColor[index],
                                      }}
                                      onClick={this.handleChange.bind(
                                        this,
                                        this.state.sdate[index],
                                        index
                                      )}
                                      data-toggle="tab"
                                    >
                                      <h4>
                                        {this.state.dateList[index]}
                                        <span>
                                          {this.state.dayList[index].substring(
                                            0,
                                            3
                                          )}
                                        </span>
                                      </h4>
                                    </a>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                        <div className="scrtabs-tab-scroll-arrow scrtabs-tab-scroll-arrow-right">
                          <span className="fa fa-angle-right"></span>
                        </div>
                      </div>

                      <div className="tab-content">
                        <div
                          className="tab-pane active"
                          id="tab1"
                          role="tabpanel"
                        >
                          {this.state.morning && this.state.mor_flag == true ? (
                            <div className="morning-date">
                              <div className="morning-top">
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/images/morning-icon.png"
                                  }
                                  alt=""
                                />{" "}
                                Morning
                              </div>
                              <ul>
                                {this.state.morning.map((slot, index) => {
                                  return (
                                    <span>
                                      {slot.patient_status == 0 &&
                                      this.state.dis_slot_morning[index] ==
                                        true &&
                                      slot.start_time.substring(6, 8) ==
                                        "AM" ? (
                                        <li>
                                          <button
                                            type="button"
                                            className="time-box"
                                            style={{
                                              backgroundColor:
                                                this.state.btnColorM[index],
                                            }}
                                            onClick={this.setSlot.bind(
                                              this,
                                              slot.id,
                                              slot.start_time,
                                              index,
                                              "morning"
                                            )}
                                          >
                                            {slot.start_time}
                                          </button>
                                        </li>
                                      ) : null}
                                    </span>
                                  );
                                })}
                              </ul>
                            </div>
                          ) : null}
                          {this.state.afternoon &&
                          this.state.after_flag == true ? (
                            <div className="morning-date">
                              <div className="morning-top">
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/images/afternoon-icon.png"
                                  }
                                  alt=""
                                />{" "}
                                Afternoon
                              </div>
                              <ul>
                                {this.state.afternoon.map((slot, index) => {
                                  return (
                                    <span>
                                      {slot.patient_status == 0 &&
                                      this.state.dis_slot_afternoon[index] ==
                                        true ? (
                                        <li>
                                          <button
                                            type="button"
                                            className="time-box"
                                            style={{
                                              backgroundColor:
                                                this.state.btnColorA[index],
                                            }}
                                            onClick={this.setSlot.bind(
                                              this,
                                              slot.id,
                                              slot.start_time,
                                              index,
                                              "afternoon"
                                            )}
                                          >
                                            {slot.start_time}
                                          </button>
                                        </li>
                                      ) : null}
                                    </span>
                                  );
                                })}
                              </ul>
                            </div>
                          ) : null}
                          {this.state.evening && this.state.eve_flag == true ? (
                            <div className="morning-date">
                              <div className="morning-top">
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/images/evening-icon.png"
                                  }
                                  alt=""
                                />{" "}
                                Evening
                              </div>
                              <ul>
                                {this.state.evening.map((slot, index) => {
                                  return (
                                    <span>
                                      {slot.patient_status == 0 &&
                                      this.state.dis_slot_evening[index] ==
                                        true ? (
                                        <li>
                                          <button
                                            type="button"
                                            className="time-box"
                                            style={{
                                              backgroundColor:
                                                this.state.btnColorE[index],
                                            }}
                                            onClick={this.setSlot.bind(
                                              this,
                                              slot.id,
                                              slot.start_time,
                                              index,
                                              "evening"
                                            )}
                                          >
                                            {slot.start_time}
                                          </button>
                                        </li>
                                      ) : null}
                                    </span>
                                  );
                                })}
                              </ul>
                            </div>
                          ) : (
                            <span className="text-center">
                              {this.state.slot_list.length == 0 ? (
                                <h6>No Slot Available</h6>
                              ) : null}
                              {/* {this.state.mor_flag == false &&
                              this.state.eve_flag == false &&
                              this.state.after_flag == false ? (
                                <h6>No Slot Available</h6>
                              ) : null} */}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {this.state.slot_id && !this.state.modalFlag ? (
            <div className="w-100 mobileFixedBook">
              <h5 className="pb-2">
                Appointment Date and Time :{" "}
                <span style={{ color: "rgb(185, 227, 95)" }}>
                  {this.state.apt_date.substring(7, 9) +
                    "/" +
                    this.state.apt_date.substring(5, 6) +
                    "/" +
                    this.state.apt_date.substring(0, 4)}{" "}
                  at {this.state.start}
                </span>
              </h5>
              <a className="next-btn" href="#" onClick={this.openModal}>
                Book
              </a>
            </div>
          ) : null}
        </section>

        {/* Modal */}
        <Modal show={this.state.modalFlag} onHide={this.closeModal}>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={this.closeModal}
          >
            &times;
          </button>
          <Modal.Body>
            <div className="row">
              <div className="col-sm-12 text-center pt-3">
                <span>
                  <label className="otp-label">+91</label>
                  <input
                    style={{ marginLeft: "0px", width: "auto" }}
                    type="text"
                    name="phone_number"
                    placeholder="Enter Phone Number"
                    className="input-col phoneInputOtp"
                    onChange={this.handleChangeForm("phone_number")}
                  />
                </span>
                <br />
                {/* <Link className="btn btn-sm mt-4" style={{color:'#ffffff',backgroundColor:'#454545',padding:'8px 30px'}} to="/dashboard"><b>Send OTP</b></Link> */}
                {!this.state.showOtpTimer ? (
                  <button
                    className="otp-btn mt-4"
                    onClick={this.onOtpSend.bind(this)}
                  >
                    {this.state.send} OTP
                  </button>
                ) : (
                  <button
                    className="otp-btn mt-4"
                    style={{ backgroundColor: "#A3A9B7" }}
                  >
                    {this.state.send} OTP
                  </button>
                )}

                <br />
                <span style={{ color: "#F969A4" }}>
                  {this.state.formErrors["phone_number"]}
                  {this.state.formErrors["otp"]}
                </span>
                <span style={{ color: "#F969A4" }}>
                  {this.state.otp_message}
                </span>
              </div>
              <div className="col-sm-12 text-left otpFields">
                {/*
                  <input
                    type="text"
                    name="otp"
                    placeholder="Enter OTP*"
                    className="otp-input"
                    onChange={this.handleChangeForm("otp")}
                  />
                  */}

                <OtpInput
                  onChange={this.handleOtp}
                  numInputs={6}
                  separator={<span></span>}
                  value={this.state.otp}
                />

                <br />
                <br />
                <span style={{ color: "#F969A4" }}></span>
                <br />
                {/* <a style={{textDecoration:'underline'}}>Resend OTP</a> */}
              </div>
              <br />
              <span style={{ color: "#F969A4", textAlign: "center" }}>
                {this.state.validation_msg}
              </span>
              <div className="col-sm-12 text-center mb-4">
                <button className="otp-btn" onClick={this.onSubmit.bind(this)}>
                  Verify
                </button>

                <span className="text-muted mt-3">
                  {this.state.showOtpTimer &&
                  !(
                    this.state.otpTimer.minutes === 0 &&
                    this.state.otpTimer.seconds === 0
                  )
                    ? `${this.state.otpTimer.minutes}:${
                        this.state.otpTimer.seconds < 10
                          ? `0${this.state.otpTimer.seconds}`
                          : this.state.otpTimer.seconds
                      } left to expire`
                    : null}
                </span>
                <span className="text-danger">
                  {this.state.otpTimer.minutes === 0 &&
                  this.state.otpTimer.seconds === 0
                    ? `OTP Expired`
                    : null}
                </span>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <GlobalFooter />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  mobileNumber: state.global.mobileNumber,
  emailId: state.global.emailId,
});

export default connect(mapStateToProps)(UserBrowser(DoctorProfile));
